// extracted by mini-css-extract-plugin
export var label = "_6r-1";
export var reminder = "_6r-0";